import { render, staticRenderFns } from "./preguntas.vue?vue&type=template&id=a5e47c06&scoped=true&"
import script from "./preguntas.vue?vue&type=script&lang=js&"
export * from "./preguntas.vue?vue&type=script&lang=js&"
import style0 from "./preguntas.vue?vue&type=style&index=0&id=a5e47c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e47c06",
  null
  
)

export default component.exports